import React, { useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import mainStyle from "../../style/Main.module.css";
import { GoFilter } from "react-icons/go";
import SearchComponent from "../../components/ui/input/Search/Search";
import Button from "../../components/ui/buttons/Button";
import { useNavigate } from "react-router-dom";
import StatusBadge from "../../components/ui/StatusBadge";
import formatDate from "../../components/ui/dateFormat";
import Select from "react-select";
import PaginationComponent from "../../components/ui/Pagination/PaginationComponent";
import NoDataFound from "../../components/ui/NoDataFound/NoDataFound";
import PageLoader from "../../components/ui/Loader/PageLoader";
// import EditUserListPage from "./EditUserListPage";
import { statusOptions } from "../../config/selectOptions";
import { useCompanyFilter } from "../../hooks/UseFilter";
import {
  useFetchChannel,
  useUpdateStatusChannel,
} from "../../hooks/useChannel";
import ChannelPeopleView from "./ChannelPeopleView";
import {
  channelAdd,
  channelEdit,
  channelStatus,
} from "../../routes/AccessCondition";
import { FiEdit } from "react-icons/fi";
import ViewChannelPopUp from "../chat/PopUp/ViewChannelPopUp";
import FallbackAvatar from "../../components/ui/FallbackAvatar/FallbackAvatar";

const ChannelPage = () => {
  const perPage = 10;
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const [showFilter, setShowFilter] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [company, setCompany] = useState("");
  const [search, setSearch] = useState("");
  const [openPeopleList, setopenPeopleList] = useState(false);
  const [datas, setDatas] = useState("");
  const [status, setStatus] = useState("");
  const [showChannelPopup, setShowChannelPopup] = useState(false);
  const [channelId, setchannelId] = useState();
  const [imageErrorsMG, setImageErrorsMG] = useState({});
  const [imageErrorsUR, setImageErrorsUR] = useState({});

  const companyFilter = useCompanyFilter();
  const addAcess = channelAdd();
  const editAccess = channelEdit();
  const statusAccess = channelStatus();

  const {
    channel: viewChannel,
    totalCount: totalEmployeeCount,
    loading: isLoading,
    refresh: refreshEmployeeList,
  } = useFetchChannel(company, search, currentPage, perPage, status);

  const toggleFilter = () => setShowFilter((prev) => !prev);
  const { updateChannelStatus, loading: updateLoading } =
    useUpdateStatusChannel();

  const handleAllCheckboxChange = () => {
    if (isAllChecked) {
      setSelectedEmployees([]);
    } else {
      setSelectedEmployees(viewChannel.map((employee) => employee.id));
    }
    setIsAllChecked(!isAllChecked);
  };

  const handleCheckboxChange = (id) => {
    setSelectedEmployees((prevState) => {
      let newSelected;
      if (prevState.includes(id)) {
        newSelected = prevState.filter((empId) => empId !== id);
      } else {
        newSelected = [...prevState, id];
      }

      // Update "Select All" checkbox state
      setIsAllChecked(newSelected.length === viewChannel.length);

      return newSelected;
    });
  };

  const currentPageNo = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };

  const handleSearch = (term) => {
    if (term !== search) {
      setSearch(term);
      setCurrentPage(1);
    }
  };

  const handleCompanyFilter = (option) => {
    if (option?.value !== company) {
      setCompany(option.value);
      setCurrentPage(1);
    }
  };

  const handleStatusUpdate = async (statusType) => {
    try {
      await updateChannelStatus(selectedEmployees, statusType);
      refreshEmployeeList();
      setSelectedEmployees([]);
      setIsAllChecked(false);
    } catch (error) {}
  };

  const handleFilterChange = (selectedOption) => {
    const newStatus = selectedOption ? selectedOption.value : "";
    if (newStatus !== status) {
      setStatus(newStatus);
      setCurrentPage(1);
    }
  };

  const addChannelPage = () => {
    navigate("/channel/add");
  };

  const openPeopleListPage = (people) => {
    const Payload = {
      people_list: people.channel_people_details,
      field: "Channel People",
      channel_name: people.channel_name,
    };
    setDatas(Payload);
    setopenPeopleList(true);
  };
  const openManagerListPage = (people) => {
    const Payload = {
      people_list: people.channel_manager_details,
      field: "Channel Managers",
      channel_name: people.channel_name,
    };
    setDatas(Payload);
    setopenPeopleList(true);
  };

  const closePeoplePopup = () => {
    setopenPeopleList(false);
    refreshEmployeeList();
  };

  const openEditPage = (id) => {
    setchannelId(id);
    setShowChannelPopup(true);
  };
  const handleUpdated = () => {
    refreshEmployeeList();
  };
  return (
    <>
      <MainLayout>
        <div className={mainStyle.mainPageHeader}>
          {selectedEmployees.length === 0 ? (
            <>
              <div>
                <p>Channel</p>
              </div>
              <div className={mainStyle.mainPageButtons}>
                <SearchComponent onSearch={handleSearch} />
                {addAcess && (
                  <Button onClick={() => navigate("/channel/add")}>
                    Add Channel
                  </Button>
                )}

                <button
                  className={mainStyle.FilterButton}
                  onClick={toggleFilter}
                >
                  <GoFilter /> Filter
                </button>
              </div>
            </>
          ) : (
            <>
              <div></div>
              <div className={mainStyle.mainPageButtons}>
                <Button
                  variant="outline-success"
                  onClick={() => handleStatusUpdate("0")}
                  disabled={updateLoading || selectedEmployees.length === 0}
                >
                  Active
                </Button>
                <Button
                  variant="outline-danger"
                  disabled={updateLoading || selectedEmployees.length === 0}
                  onClick={() => handleStatusUpdate("1")}
                >
                  Deactive
                </Button>
              </div>
            </>
          )}
        </div>

        {showFilter && (
          <div className={mainStyle.mainPageFilter}>
            <div className={mainStyle.mainPageFilterSub}>
              <div className={mainStyle.mainPageFilterDiv}>
                <span>Company</span>
                <Select
                  className={mainStyle.pagesFilter}
                  placeholder="Select Company"
                  options={companyFilter}
                  onChange={handleCompanyFilter}
                  value={companyFilter.find(
                    (option) => option.value === company
                  )}
                />
              </div>
              <div className={mainStyle.mainPageFilterDiv}>
                <span>Status</span>
                <Select
                  className={mainStyle.pagesFilter}
                  placeholder="Action"
                  options={statusOptions}
                  onChange={handleFilterChange}
                  value={statusOptions.find(
                    (option) => option.value === status
                  )}
                />
              </div>
            </div>
          </div>
        )}

        <div
          className={mainStyle.mainContentView}
          style={{ height: showFilter ? "78%" : "92%" }}
        >
          {isLoading ? (
            <PageLoader />
          ) : (
            <div className={mainStyle.mainContentViewsb}>
              {viewChannel && viewChannel.length > 0 ? (
                <div className={mainStyle.mainTableDiv}>
                  <table className={mainStyle.mainTable}>
                    <thead className={mainStyle.mainTableHead}>
                      <tr>
                        {statusAccess && (
                          <th>
                            <input
                              type="checkbox"
                              checked={isAllChecked}
                              onChange={handleAllCheckboxChange}
                            />
                          </th>
                        )}

                        <th># Channel</th>
                        <th>Channel Manager</th>
                        <th>Company</th>
                        <th>Staff</th>
                        <th>Status</th>
                        <th>Joining Date</th>
                        {editAccess && <th>##</th>}
                      </tr>
                    </thead>

                    <tbody className={mainStyle.mainTableBody}>
                      {viewChannel.map((emp, index) => (
                        <tr key={emp.id || index}>
                          {statusAccess && (
                            <td>
                              <input
                                type="checkbox"
                                checked={selectedEmployees.includes(emp.id)}
                                onChange={() => handleCheckboxChange(emp.id)}
                              />
                            </td>
                          )}

                          <td>
                            <div className={mainStyle.tableImgViewdiv}>
                              <div>
                                {/* <div className={mainStyle.tableImgView}>
                                  <img
                                    src={`${apiUrl}${emp.emp_pic}`}
                                    alt="img"
                                  />
                                </div> */}
                              </div>
                              <div className={mainStyle.tableImgViewContent}>
                                <div
                                  className={mainStyle.tableImgViewContentName}
                                >
                                  {`${emp.channel_name} `}
                                </div>
                                <div className={mainStyle.tableTextOverFlow}>
                                  {emp.channel_topic}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td>
                            {emp.channel_manager_details &&
                              emp.channel_manager_details.length > 0 && (
                                <div
                                  className={mainStyle.companyLogosContainer}
                                  onClick={() => openManagerListPage(emp)}
                                  style={{ cursor: "pointer" }}
                                >
                                  {emp.channel_manager_details
                                    .slice(0, 3)
                                    .map((company, i) => {
                                      const hasError =
                                        imageErrorsMG[company.id];
                                      return (
                                        <div
                                          key={i}
                                          className={
                                            mainStyle.companyLogoWrapper
                                          }
                                        >
                                          {!hasError && company.emp_pic ? (
                                            <img
                                              src={`${apiUrl}${company.emp_pic}`}
                                              alt={company.first_name}
                                              className={mainStyle.companyLogo}
                                              onError={() =>
                                                setImageErrorsMG((prev) => ({
                                                  ...prev,
                                                  [company.id]: true,
                                                }))
                                              }
                                            />
                                          ) : (
                                            <FallbackAvatar
                                              name={`${company.first_name} ${company.last_name}`}
                                              size={40}
                                            />
                                          )}
                                        </div>
                                      );
                                    })}
                                  {emp.channel_manager_details.length > 3 && (
                                    <div
                                      className={
                                        mainStyle.moreCompaniesIndicator
                                      }
                                    >
                                      +{emp.channel_manager_details.length - 3}
                                    </div>
                                  )}
                                </div>
                              )}
                          </td>
                          <td>
                            <div className={mainStyle.tableImgView}>
                              <img
                                src={`${apiUrl}${emp?.get_company_details[0]?.company_logo}`}
                                alt="img"
                              />
                            </div>
                          </td>
                          <td>
                            {emp.channel_people_details &&
                              emp.channel_people_details.length > 0 && (
                                <div
                                  className={mainStyle.companyLogosContainer}
                                  onClick={() => openPeopleListPage(emp)}
                                  style={{ cursor: "pointer" }}
                                >
                                  {emp.channel_people_details
                                    .slice(0, 3)
                                    .map((company, i) => {
                                      const hasError =
                                        imageErrorsUR[company.id];
                                      return (
                                        <div
                                          key={i}
                                          className={
                                            mainStyle.companyLogoWrapper
                                          }
                                        >
                                          {!hasError && company.emp_pic ? (
                                            <img
                                              src={`${apiUrl}${company.emp_pic}`}
                                              alt={company.first_name}
                                              className={mainStyle.companyLogo}
                                              onError={() =>
                                                setImageErrorsUR((prev) => ({
                                                  ...prev,
                                                  [company.id]: true,
                                                }))
                                              }
                                            />
                                          ) : (
                                            <FallbackAvatar
                                              name={`${company.first_name} ${company.last_name}`}
                                              size={40}
                                            />
                                          )}
                                        </div>
                                      );
                                    })}

                                  {/* {emp.channel_people_details
                                    .slice(0, 3)
                                    .map((company, i) => (
                                      <img
                                        key={i}
                                        src={`${apiUrl}${company.emp_pic}`}
                                        alt={company.first_name}
                                        className={mainStyle.companyLogo}
                                      />
                                    ))} */}
                                  {emp.channel_people_details.length > 3 && (
                                    <div
                                      className={
                                        mainStyle.moreCompaniesIndicator
                                      }
                                    >
                                      +{emp.channel_people_details.length - 3}
                                    </div>
                                  )}
                                </div>
                              )}
                          </td>
                          <td>
                            <StatusBadge status={emp.channel_status} />
                          </td>
                          <td>{formatDate(emp.create_date)}</td>
                          {editAccess && emp.channel_status === "0" && (
                            <td>
                              <FiEdit
                                onClick={() => openEditPage(emp.id)}
                                style={{ cursor: "pointer" }}
                              />
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <NoDataFound
                  title="No Channel Found"
                  description="No channel found. Click the button below to add a new."
                  buttonText="Add Channel"
                  onButtonClick={addChannelPage}
                />
              )}

              <div>
                {!isLoading && totalEmployeeCount > perPage && (
                  <PaginationComponent
                    pageCount={Math.ceil(totalEmployeeCount / perPage)}
                    onPageChange={currentPageNo}
                    forcePage={currentPage - 1}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </MainLayout>
      {openPeopleList && (
        <ChannelPeopleView
          data={datas}
          show={openPeopleList}
          onClose={closePeoplePopup}
        />
      )}
      {showChannelPopup && (
        <ViewChannelPopUp
          onClose={() => setShowChannelPopup(false)}
          channelId={channelId}
          updated={handleUpdated}
        />
      )}
    </>
  );
};

export default ChannelPage;
